export default function ThreadsLogo({ size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" data-testid="threads-logo">
      <rect x="2" y="2" width="36" height="36" rx="9" fill="#111" />
      <path d="M13 14h14M13 20h14M13 26h9" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
      <circle cx="27.5" cy="26" r="1.8" fill="#e8c547" />
    </svg>
  );
}
